import { render, staticRenderFns } from "./AppointmentCapacityTable.vue?vue&type=template&id=6c6a8711&scoped=true"
import script from "./AppointmentCapacityTable.vue?vue&type=script&lang=js"
export * from "./AppointmentCapacityTable.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCapacityTable.vue?vue&type=style&index=0&id=6c6a8711&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a8711",
  null
  
)

export default component.exports